
import { useContext, useEffect, useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import "./SpaceHighlightInput.scss"


export const SpaceHighlightInput = ({
    className="",
    value,
    onChange,
    style,
    name,
    autoComplete,
    disabled = false
}) => {
    const [displayValue, setDisplayValue] = useState(value || "");
    const inputRef = useRef(null);
    const overlayRef = useRef(null);

    useEffect(() => {
        setDisplayValue(value || "");
    }, [value]);

    const handleChange = (e) => {
        const val = e.target.value;
        setDisplayValue(val);
        if (onChange) onChange(e);
    };

    const handleScroll = () => {
        if (overlayRef.current && inputRef.current) {
            overlayRef.current.scrollLeft = inputRef.current.scrollLeft;
        }
    };

    const getHighlightedText = (text) =>
        text.split("").map((char, index) =>
            char === " " ? (
                <span key={index} style={{ backgroundColor: "var(--yellow-500)" }}>
                    &nbsp;
                </span>
            ) : (
                char
            )
        );

    return (
        <div className="custom-input" style={{ position: "relative", width: "100%", ...style }}>
            <div
                ref={overlayRef}
                className= {"text-overlay "+className}
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    pointerEvents: "none",
                    whiteSpace: "pre",
                    color: "transparent",
                    overflow: "hidden",
                    width: "100%",
                    boxSizing: "border-box",
                }}
            >
                {getHighlightedText(displayValue)}
            </div>

            <InputText
                ref={inputRef}
                name={name}
                autoComplete={autoComplete}
                value={displayValue}
                onChange={handleChange}
                onScroll={handleScroll}
                disabled={disabled}
                style={{
                    position: "relative",
                    background: "transparent",
                    color: "black",
                    width: "100%",
                    boxSizing: "border-box",
                    overflowX: "auto",
                    whiteSpace: "pre",
                }}
            />
        </div>
    );
};
